// Central manifest of licensed photography used across QuantumResults.com.
// All Unsplash photos are used under the Unsplash License (https://unsplash.com/license).
// Attribution is displayed on-site as a courtesy.

const u = (id) => `https://images.unsplash.com/${id}?w=1600&q=80&auto=format&fit=crop`;
const c = (name) => `Photo — ${name} · Unsplash`;

export const IMG = {
  home: {
    welcome: { src: u("photo-1470071459604-3b5ec3a7fe05"), alt: "A tranquil misty valley opening into distance at first light", credit: c("eberhard grossgasteiger") },
    meetDan: { src: u("photo-1518495973542-4542c06a5843"), alt: "Soft afternoon light streaming through a stand of trees", credit: c("Casey Horner") },
    resourcesTeaser: { src: u("photo-1524995997946-a1c2e315a42f"), alt: "An open book resting on a wooden surface in warm light", credit: c("Kelly Sikkema") },
    wherever: { src: u("photo-1470252649378-9c29740c9fa8"), alt: "A quiet path forward through wildflowers", credit: c("Sylwia Bartyzel") },
  },
  about: {
    hero: { src: u("photo-1506905925346-21bda4d32df4"), alt: "A solitary walker on a winding mountain road at dusk", credit: c("Denys Nevozhai") },
    danPortrait: { src: "/brand/dan-hoover.png", alt: "Dan Hoover, founder of Quantum Results, standing in a quiet corridor", credit: "" },
    belief: { src: u("photo-1512389142860-9c449e58a543"), alt: "A quiet horizon of land and sky in gentle balance", credit: c("Jeff Finley") },
    question: { src: u("photo-1519681393784-d120267933ba"), alt: "A wide mountain vista under a still sky", credit: c("Sergey Pesterev") },
    experience: { src: u("photo-1476820865390-c52aeebb9891"), alt: "A gentle path curving through a quiet forest", credit: c("Casey Horner") },
    why: { src: u("photo-1439066615861-d1af74d74000"), alt: "Sunrise glowing across still water", credit: c("David Marcu") },
  },
  fourLevels: {
    hero: { src: u("photo-1464822759023-fed622ff2c3b"), alt: "Layered misty mountains fading softly into distance", credit: c("Nathan Anderson") },
    recognition: { src: u("photo-1502082553048-f009c37129b9"), alt: "Dappled sunlight moving across a peaceful forest floor", credit: c("Johannes Plenio") },
    framework: { src: u("photo-1470071459604-3b5ec3a7fe05"), alt: "A calm valley wrapped in early-morning mist", credit: c("eberhard grossgasteiger") },
  },
  patternReveal: {
    hero: { src: u("photo-1500673922987-e212871fec22"), alt: "Rippling water reflecting light in soft patterns", credit: c("v2osk") },
    recognition: { src: u("photo-1500534314209-a25ddb2bd429"), alt: "A ridge of mountains repeating in soft rhythm at dawn", credit: c("Casey Horner") },
    patterns: { src: u("photo-1441974231531-c6227db76b6e"), alt: "A cathedral of tall trees repeating in gentle rhythm", credit: c("Lukasz Szmigiel") },
  },
  weeklyEdge: {
    hero: { src: u("photo-1490604001847-b712b0c2f967"), alt: "A soft, luminous horizon at the edge of day", credit: c("Lachlan Gowen") },
    keepGrowing: { src: u("photo-1493246507139-91e8fad9978e"), alt: "Morning light filtering softly through tall trees", credit: c("Simon Berger") },
  },
  forwardReset: {
    hero: { src: u("photo-1447752875215-b2761acb3c5d"), alt: "A footpath curving quietly into a still forest", credit: c("Jay Mantri") },
    begin: { src: u("photo-1495197359483-d092478c170a"), alt: "A quiet chair positioned by a window with soft light", credit: c("Sergei Solo") },
  },
  dailyEdge: {
    hero: { src: u("photo-1439066615861-d1af74d74000"), alt: "Sunrise glowing across still water", credit: c("David Marcu") },
    recognition: { src: u("photo-1493246507139-91e8fad9978e"), alt: "Morning light filtering softly through tall trees", credit: c("Simon Berger") },
  },
  resources: {
    hero: { src: u("photo-1524995997946-a1c2e315a42f"), alt: "An open book resting on a wooden surface in warm light", credit: c("Kelly Sikkema") },
  },
  contact: {
    hero: { src: u("photo-1470252649378-9c29740c9fa8"), alt: "A quiet path forward through wildflowers", credit: c("Sylwia Bartyzel") },
  },
};

export default IMG;
